import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import css from 'styled-jsx/css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import IconsContext from '../Context/IconsContext';

const { className: searchSpinnerclass, styles: searchSpinnerStyles } =
  css.resolve`
    svg {
      position: static;
      width: 100%;
    }

    @media (min-width: 992px) {
      svg {
        position: absolute;
        top: 35%;
        left: 0;
      }
    }
  `;

export const NoItemsFound = ({ text }) => (
  <p className="text-center text-text-light-gray">{text}</p>
);

NoItemsFound.propTypes = { text: PropTypes.string };

export const NoItemsExist = (props) => {
  const { emptyStateIcon } = useContext(IconsContext);
  const {
    alt,
    altMessage = '',
    color = 'blue',
    height = 100,
    icon = emptyStateIcon,
    reminders = false,
    text,
    width = 100,
  } = props;
  return (
    <div className={`${reminders ? 'h-100' : ''} text-center`}>
      <img
        src={icon}
        alt={alt}
        className="mx-auto"
        height={height}
        width={width}
      />
      {text ? (
        <p className="text-text-light-gray three-quarter-text mb-2">{text}</p>
      ) : null}
      <p className="text-muted nine-tenth-text">
        {altMessage || `Click the ${color} button to create some!`}
      </p>
    </div>
  );
};

NoItemsExist.propTypes = {
  alt: PropTypes.string,
  altMessage: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  reminders: PropTypes.bool,
  text: PropTypes.string,
  width: PropTypes.number,
};

export const NoResultsFound = ({ searchTerm }) => (
  <div className="container position-static w-100 text-center mt-2 mt-lg-0 d-lg-flex flex-lg-column justify-content-lg-center">
    <span className="font-weight-bold text-text-light-gray">{`No results found for "${searchTerm}"`}</span>
    <span className="text-text-light-gray">
      Please check your spelling or use different keywords.
    </span>
    <style jsx>{`
      @media (min-width: 992px) {
        .container {
          height: 100%;
        }
      }
    `}</style>
  </div>
);

NoResultsFound.propTypes = { searchTerm: PropTypes.string };

export const Loading = ({ size = '2x' }) => (
  <FontAwesomeIcon
    className="w-100"
    color="var(--brand-primary)"
    icon={faCircleNotch}
    size={size}
    spin
  />
);

Loading.propTypes = { size: PropTypes.string };

export const SearchLoading = () => (
  <>
    <FontAwesomeIcon
      className={`${searchSpinnerclass} mt-3 mt-lg-0`}
      color="var(--brand-primary)"
      icon={faCircleNotch}
      size="2x"
      spin
    />
    {searchSpinnerStyles}
  </>
);
